import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  image: {
    display: "block",
    margin: "auto",
    width: "80%"
  } 
}));

export default useStyles